import { URL_SELECTION_ITEM_LIST } from '@tools/routes/routes';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import SelectionItem from './SelectionItem.vue';

export const initSelectionItems = () => {
  if (!document.getElementById('selection-item-app')) {
    return;
  }

  const pinia = createPinia();

  const app = createApp(SelectionItem);

  app.config.globalProperties.$companyName = window.COMPANY_NAME;
  app.config.globalProperties.$areaUnit = window.AREA_UNIT;
  app.config.globalProperties.$newLabelDuration = 604800;

  const routes = [
    {
      path: URL_SELECTION_ITEM_LIST,
      name: 'selectionItem',
      component: SelectionItem,
    },
  ];

  const router = createRouter({
    routes,
    history: createWebHistory(),
    scrollBehavior: () => Promise.resolve({ left: 0, top: 0 }),
  });

  app.use(router);
  app.use(pinia);
  app.mount('#selection-item-app');
};
